import { render } from "./agent_detail.vue?vue&type=template&id=4a9a9bb2"
import script from "./agent_detail.vue?vue&type=script&lang=js"
export * from "./agent_detail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/home/Documents/kevin/ftd_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__